const Raids = () => import(/* webpackChunkName: "Catalogs" */ 'RootDir/modules/HuntingSupervision/Raids.vue');

export default [
  {
    path: 'raids',
    name: 'hunting-supervision-raids',
    component: Raids,
  },
];
